<template>
    <span>
        {{time}}
    </span>
</template>

<script>
  import {PPComponentMixin} from "../mixins";
  import {durationToString} from "../utils";

  export default {
    name: "PPLabelCurrentTime",
    mixins: [PPComponentMixin],
    computed: {
      time() {
        if(!this.player || this.player.duration === Number.NaN
          || this.player.duration < 0
          || this.player.duration === Infinity) {
          return "--:--:--";
        }
        if (this.player.hoverPosition >= 0) {
          return durationToString(Math.round(this.player.hoverPosition))
        }
        if (this.player.targetPosition >= 0) {
          return durationToString(Math.round(this.player.targetPosition))
        }
        return durationToString(Math.round(this.player.currentTime))
      }
    }
  }
</script>
